jQuery(function ($) {
    const slideTime = 200;
    $('.conditional-check').change(function (e) {
        const row = $(this).closest('.form-group').next();
        const value = parseInt($(this).val());

        if (value === 1){
            row.slideDown(slideTime);
        } else {
            row.slideUp(slideTime);
        }
    });

    $('input[name="ceremony_type"]').change(function (e) {
        showOther(this, '4');
    });
    $('input[name="bury_type"]').change(function (e) {
        showOther(this, '4');
    });
    function showOther(input, val) {
        const $this = $(input);
        const obj = $this.closest('.col-12').find('.other-field');
        if ($this.val() === val){
            obj.show()
        } else {
            obj.val('').hide();
        }
    }

    $('#add-contact-row').on('click', function (e) {
        e.preventDefault();

        const existingRowsCount = $('#contact-rows > div').length;
        const tempalte = `
            <div class="row contact-row" style="display: none;">
                <div class="col-6">
                    <label>Namn:</label><input type="text" class="form-control" name="contact_persons[${existingRowsCount}][name]">
                </div>
                <div class="col-6">
                    <label>Tel:</label><input type="text" class="form-control" name="contact_persons[${existingRowsCount}][tel]">
                </div>
            </div>
        `;

        $(tempalte).appendTo("#contact-rows").slideDown();
    })
    $('.online-form-section-control').on('click', 'button', function (e) {
        e.preventDefault();

        const direction = $(this).data('direction');
        const type = $(this).attr('type');
        if (direction === 'next' && type === 'submit'){
            $('#onlineform').submit();
        }
        showStages(direction);
    });

    $('#onlineform').validate({
        rules: {},
        submitHandler: function(form, e) {
            e.preventDefault();
            const button = $('button[type=submit]');
            button.prop('disabled', true);

            $.post('', $('#onlineform').serialize()).done(function( data ) {
                if (data.status === 'success') {
                    $('.online-form-thanks').show();
                    $('.online-form-content').hide();
                    $("html, body").animate({ scrollTop: 0 }, "slow");
                } else if(data.status === 'error'){}
            }).always(function () {
                button.prop('disabled', false);
            });
        }
    });

    function showStages(direction) {
        const cont = $('.online-form-section-wrapper');
        const active = cont.find('.active');
        const nth = active.index('.online-form-section') + 1;
        let hasErrors = 0;
        const required = requiredFields();

        if (direction === 'prev' && active.prev().length) {
            scrollToElement(() => {
                active.prev().addClass('active');
                active.removeClass('active');
                updateProgress();
            });
        }

        if (direction === 'next' && active.next().length) {
            active.find('.error').remove();

            if (required[nth]){
                required[nth].map(function (selector) {
                    const el = $(`input[name="${selector}"]`);
                    if (el.attr('type') === 'radio') {
                        const isCheched = el.is(':checked');

                        if (!isCheched){
                            el.closest('.col-12').append(`<label class="error stage-element-error" for="${selector}">Detta fält är obligatoriskt.</label>`);
                            hasErrors = 1;
                        }
                    }

                    if (el.attr('type') === 'text' || el.attr('type') === 'email') {
                        const val = el.val();

                        if (val === ''){
                            el.closest('div').append(`<label class="error stage-element-error" for="${selector}">Detta fält är obligatoriskt.</label>`);
                            hasErrors = 1;
                        }
                    }
                })
            }

            if (hasErrors){
                const errorEl = active.find('label.error').eq(0);
                scrollToElement(null, errorEl, -250);

                return false;
            }

            scrollToElement(() => {
                active.next().addClass('active');
                active.removeClass('active');
                updateProgress();
            });
        }
    }
    function updateProgress() {
        const wrp = $('.online-form-progress-wrapper');
        const bar = $('.online-form-progress-bar');
        const nth = $('.online-form-section.active').index('.online-form-section');
        const btn = $('.online-form-section-control .next');

        let value = 0;
        let display = 'flex';

        switch (nth) {
            case 1:
                value = 48;
                break;
            case 2:
                value = 60;
                break;
            case 3:
                value = 80;
                break;
            case 0:
            default:
                display = 'none';
                break;
        }

        wrp.css('display', display);
        bar.css('width', `${value}%`);
        $('.online-form-progress-wrapper > span').html(`${value}%`);

        if (nth === 3){
            btn.html('Skicka in')
            btn.attr('type', 'submit')
        } else{
            btn.html('Nästa');
            btn.attr('type', 'button')
        }
    }
    function scrollToElement(func, el = '.online-form-section-title', offset = -200) {
        $('html, body').animate({
            scrollTop: $(el).offset().top + offset
        }, slideTime, func);
    }
    function requiredFields() {
        return {
            1: ['username', 'lastname', 'email']
        }
    }
});